function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ExternalApp = /*#__PURE__*/function () {
  function ExternalApp() {
    _classCallCheck(this, ExternalApp);
  }

  _createClass(ExternalApp, [{
    key: "setList",
    value: function setList(list) {
      this.list = list;
    }
  }, {
    key: "isEnableIntercom",
    value: function isEnableIntercom() {
      return this.isEnable(ExternalApp.INTERCOM);
    }
  }, {
    key: "isEnableGoogleTagManager",
    value: function isEnableGoogleTagManager() {
      return this.isEnable(ExternalApp.GOOGLE_TAG_MANAGER);
    }
  }, {
    key: "isEnable",
    value: function isEnable(name) {
      var _this$list$name;

      if (!this.list) {
        return false;
      }

      return (_this$list$name = this.list[name]) !== null && _this$list$name !== void 0 ? _this$list$name : false;
    }
  }]);

  return ExternalApp;
}();

_defineProperty(ExternalApp, "INTERCOM", 'intercom');

_defineProperty(ExternalApp, "GOOGLE_TAG_MANAGER", 'googleGtm');

export { ExternalApp };